module.exports = __webpack_public_path__ + "img/enterprise-road-2.4d2592ec.png";